import { createContext, useState } from "react";
import { getErrorMessageFromError } from "../../components/ErrorMessage";
import { useApp } from "../../hooks/useApp";
import { CountryPhoneDto } from "../../model/CountryPhoneDto";
import { SVCountryPhoneRequest } from "../../services/countryPhone/CountryPhoneService";

const CountryPhoneContext = createContext();

const CountryPhoneContextProvider = ({ children }) => {
    const [listCountryPhone, setListCountryPhone] = useState([]);
    const [selectedCountryPhone, setSelectedCountryPhone] = useState(null);

    const { 
        setErrorMsg,
        setLoading,
    } = useApp();

    const loadCountryPhone = async () => {
        // console.log("desde contexts");
        try {
            let responseCountryPhoneList = await SVCountryPhoneRequest(0,50);
            // console.log("responseCountryPhoneList", responseCountryPhoneList);
            const countryPhone = responseCountryPhoneList.content.map(countryPhoneData => {
                return new CountryPhoneDto(
                    countryPhoneData.id,
                    countryPhoneData.countryName,
                    countryPhoneData.countryCode,
                    countryPhoneData.phoneNumber
                );
            })
            setListCountryPhone(countryPhone);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            const errorMessage = getErrorMessageFromError(error);
            setErrorMsg(errorMessage)
            setLoading(false);
        }
    }

    return (
        <CountryPhoneContext.Provider value={{
            listCountryPhone,
            loadCountryPhone,
            setSelectedCountryPhone,
            selectedCountryPhone
        }}>
            {children}
        </CountryPhoneContext.Provider>
    )
}

export { CountryPhoneContext, CountryPhoneContextProvider };